<template>
    <div class="container">
        <div class="order-info">
            <div class="order-status">
                <van-icon name="passed" size="48" color="#07c160" />
                <h3>预约成功</h3>
            </div>

            <div class="order-detail" v-if="orderInfo">
                <ul>
                    <li>
                        <span class="item-text">体检人员</span>
                        <span class="item-value">{{orderInfo.name}}</span>
                    </li>
                    <li>
                        <span class="item-text">体检单位</span>
                        <span class="item-value">{{orderInfo.companyName}} - ({{orderInfo.companyBatchName}}）</span>
                    </li>
                    <li>
                        <span class="item-text">体检机构</span>
                        <span class="item-value">{{hospInfo.name}}</span>
                    </li>
                    <li>
                        <span class="item-text">体检地点</span>
                        <span class="item-value">{{hospInfo.address}}</span>
                    </li>
                    <li>
                        <span class="item-text">体检时间</span>
                        <span class="item-value">{{orderInfo.appointDate}} {{orderInfo.appointTimeRangeName}}</span>
                    </li>
                    <li>
                        <span class="item-text">体检编号</span>
                        <span class="item-value">{{orderInfo.examNo}}</span>
                    </li>
                </ul>
            </div>


        </div>
        <div class="footer">
            <router-link to="/">
                <van-button type="info" size="large" round plain>返回首页</van-button>
            </router-link>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .container {
        min-height: 100vh;
        background: #fff;
    }

    .order-info {
        background: #fff;
        padding: 32px 24px;
        margin-bottom: 12px;
        text-align: center;

        .order-status {
            padding-bottom: 24px;
            margin-bottom: 24px;
            border-bottom: 1px solid #ebedf0;

            h3 {
                font-size: 20px;
                margin-top: 8px;
            }
        }

        .order-detail {
            text-align: left;
            font-size: 14px;

            li {
                list-style: none;
                display: flex;
                line-height: 32px;

                .item-text {
                    width: 80px;
                    color: #888;
                }

                .item-value {
                    flex: 1;
                }
            }
        }
    }

    .order-action {
        padding: 12px;
        background: #fff;
    }

    .footer {
        padding: 24px;
    }
</style>

<script>
    import {
        mapState,
        mapMutations,
        mapActions
    } from "vuex";
    export default {
        data() {
            return {
                orderInfo: null,
            }
        },
        created() {
            this.orderInfo = JSON.parse(decodeURIComponent(this.$route.params.orderinfo));
        },
        computed: {
            ...mapState({
                hospInfo: state => state.hospital.hospInfo
            })
        },
    }
</script>